import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import coreActions from "../../state/reducers/core/coreActions.js";

import { resetErrors } from "../../state/reducers/api/apiActions.js";

class LinkWithReset extends PureComponent {
  // -- HANDLER -- //

  doResets = () => {
    const { resetWatchers, resetErrors, onClick } = this.props;

    resetWatchers();
    resetErrors();

    if (onClick) onClick();
  };

  // -- RENDER -- //

  render() {
    let linkProps = { ...this.props };

    // deleting to avoid DOM element errors in <Link />
    delete linkProps.resetWatchers;
    delete linkProps.resetErrors;
    delete linkProps.onClick;

    return <Link {...linkProps} onClick={this.doResets} />;
  }
}

const mapDispatchToProps = dispatch => ({
  resetWatchers: () => dispatch(coreActions.resetWatchers()),
  resetErrors: () => dispatch(resetErrors())
});

export default connect(null, mapDispatchToProps)(LinkWithReset);
